import { CardCommentListObjectType, UnionExtraData, UnionExtraDataListObjectType } from 'constants/graphqlTypes';

export const addListenerMulti = (element: HTMLDivElement | null, events: string[], listener: () => void): void => {
  events.forEach((event) => element?.addEventListener(event, listener));
};

export const removeListenerMulti = (element: HTMLDivElement | null, events: string[], listener: () => void): void => {
  events.forEach((event) => element?.removeEventListener(event, listener));
};

export const getFilteredActions = (
  extraData?: UnionExtraDataListObjectType | null,
  isDiscovery?: boolean,
  comments?: CardCommentListObjectType | null
): UnionExtraData[] => {
  const extraDataItems = extraData?.items ?? [];

  // Check if extraData has any non-suspicious thoughts
  const hasThoughtsInExtraData = extraDataItems.some(
    (action) => action?.__typename === 'CardCommentSchema' && !action.isSuspicious
  );

  // If no thoughts in extraData but we have comments, use comments as fallback
  if (!hasThoughtsInExtraData && comments?.items?.length) {
    const firstComment = comments.items[0];
    if (firstComment && !firstComment.isSuspicious && firstComment.user) {
      // Return the comment as a CardCommentSchema-like object
      // Use updatedAt as fallback for createdAt if not available
      const dateValue = firstComment.createdAt || firstComment.updatedAt || new Date().toISOString();
      return [
        {
          __typename: 'CardCommentSchema' as const,
          id: firstComment.id,
          text: firstComment.text,
          createdAt: dateValue,
          updatedAt: firstComment.updatedAt || dateValue,
          isSuspicious: firstComment.isSuspicious,
          user: firstComment.user,
        },
      ] as UnionExtraData[];
    }
  }

  if (!extraDataItems.length) return [];

  const hasCommentsInFallbacks =
    extraDataItems.length > 1 && extraDataItems.some((action) => action?.__typename === 'CardCommentSchema');

  if (hasCommentsInFallbacks && isDiscovery) {
    return extraDataItems.filter(
      (action) =>
        (action.__typename === 'CardCommentSchema' && !action.isSuspicious) ||
        action.__typename === 'CardPickSchema' ||
        action.__typename === 'CollectionCardLinkSchema'
    );
  }

  if (hasCommentsInFallbacks && !isDiscovery) {
    return extraDataItems.filter((action) => action.__typename === 'CardCommentSchema' && !action.isSuspicious);
  }

  return extraDataItems;
};
